import PendingUsersTable from './PendingUsersTable';
export default PendingUsersTable;